import { Button } from '@/components/buttons';
import GroupCard from '@/components/GroupCard';
import styled from '@emotion/styled';

export const RecommendedGroupsContainer = styled.div`
  grid-area: groups;
  margin-bottom: 0;

  @media screen and (min-width: 768px) {
    margin-bottom: 76px;
  }
`;

export const Title = styled.h3`
  font-size: 24px;
  font-weight: bold;
  padding: 60px 0 0 39px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const TileCarouseContainer = styled.div`
  margin: 22px -6.4px 0 -8px;

  @media (max-width: 768px) {
    margin: 30px -7px 0 -7px;
  }
`;

export const StyledGroupCard = styled(GroupCard)`
  margin: 0;
  width: 100% !important;
`;

export const ContentContainer = styled.div`
  margin-top: 30px;

  @media (max-width: 768px) {
    margin: 22px 24px 0 24px;
  }
`;

export const BrowseMoreButtonStyled = styled(Button)`
  height: 50px;
  font-size: 18px;
  line-height: 53px;
  border-radius: 20px;

  @media (max-width: 768px) {
    height: 40px;
    font-size: 16px;
    line-height: 53px;
  }
`;

export const BrowseMoreButtonContainer = styled.div`
  width: 100%;
  display: flex;
  margin-top: 76px;
  justify-content: center;

  @media (max-width: 768px) {
    margin-bottom: 76px;
  }
`;
